import get from 'lodash/get';
import map from 'lodash/map';
import { Spin, Descriptions, Space, Image, Modal, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PlayCircleOutlined } from '@ant-design/icons';
import { offeringManagement } from '../../redux/actions/offeringAction';
import { productSelectionColumns } from '../../constants/catalogue';

const OfferingDetails = ({ offering }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [offeringDetails, setOfferingDetails] = useState(null);
  const [videoPreview, setVideoPreview] = useState({
    visible: false,
    filePath: null,
  });
  const role = useSelector((state) => get(state, 'auth.role'));

  const fetchOfferDetail = () => {
    setLoading(true);
    dispatch(
      offeringManagement('get.offering', {
        id: get(offering, 'id'),
        company_id: get(offering, 'company_id'),
      })
    )
      .then((result) => {
        setOfferingDetails(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(true);
      });
  };

  const toggleVideoPreview = (filePath = null) => {
    setVideoPreview({
      visible: !get(videoPreview, 'visible'),
      filePath,
    });
  };

  useEffect(() => {
    fetchOfferDetail();
  }, []);

  return (
    <Spin spinning={loading}>
      <div className="product-final-confirmation-container">
        <Descriptions bordered column={2} size="small">
          <Descriptions.Item label="Channel">
            <Space size="large">
              <Image
                src={get(offeringDetails, 'SalesChannel.image')}
                width={50}
                height={50}
              />
              {get(offeringDetails, 'SalesChannel.name')}
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="mt-40">
        <p className="normal-heading ">Offering details</p>
      </div>
      <div className="product-final-confirmation-container ">
        <Descriptions bordered column={4} layout="vertical" size="small">
          <Descriptions.Item label="Offering Name">
            {get(offeringDetails, 'name')}
          </Descriptions.Item>
          <Descriptions.Item label="MRP">
            {get(offeringDetails, 'mrp')}
          </Descriptions.Item>
          <Descriptions.Item label="Number of Items">
            {get(offeringDetails, 'item_count')}
          </Descriptions.Item>
          <Descriptions.Item label="Discount (%)">
            {get(offeringDetails, 'discount_percent')}
          </Descriptions.Item>
          <Descriptions.Item label="Availability">
            {get(offeringDetails, 'availability') === 'SELECTIVE'
              ? 'Selective'
              : 'Public'}
          </Descriptions.Item>
          {get(offeringDetails, 'availability') === 'SELECTIVE' && (
            <Descriptions.Item label="Retailers">
              {map(
                get(offeringDetails, 'OfferingPartnerRetailers', []),
                (retailer, i) => (
                  <Tag key={i}>{get(retailer, 'PartnerRetailer.name')}</Tag>
                )
              )}
            </Descriptions.Item>
          )}
        </Descriptions>
      </div>

      <div className="mt-40">
        <p className="normal-heading ">Products</p>
      </div>
      <div className="product-description-container">
        <Table
          bordered
          dataSource={map(get(offeringDetails, 'OfferingProducts'), (prod) => ({
            ...get(prod, 'Product'),
            quantity: get(prod, 'item_count'),
          }))}
          columns={productSelectionColumns(false, get(role, 'role_code'))}
          pagination={false}
        />
      </div>
      {get(offeringDetails, 'OfferingMedia', []).length > 0 && (
        <>
          <div className="mt-40">
            <p className="normal-heading ">Media </p>
          </div>
          <div className="media-section">
            {map(get(offeringDetails, 'OfferingMedia'), (m, index) => {
              if (get(m, 'type') === 1) {
                return (
                  <Image
                    key={index}
                    src={get(m, 'file_path')}
                    className="img-upload-btn"
                    style={{
                      border: ' 1px dashed #d9d9d9',
                    }}
                  />
                );
              }

              return (
                <div className="img-upload-btn">
                  <PlayCircleOutlined
                    className="table-icon"
                    onClick={() => {
                      toggleVideoPreview(get(m, 'file_path'));
                    }}
                  />
                </div>
              );
            })}
          </div>
        </>
      )}

      {get(offeringDetails, 'other_info') && (
        <>
          <div className="mt-40">
            <p className="normal-heading ">Other Necessary Information </p>
          </div>
          <div className="product-description-container ">
            <Descriptions bordered column={1} size="small">
              <Descriptions.Item>
                {get(offeringDetails, 'other_info')}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </>
      )}

      <Modal
        width="50%"
        destroyOnClose
        open={get(videoPreview, 'visible')}
        onOk={toggleVideoPreview}
        onCancel={toggleVideoPreview}
        footer={null}
        className="video-preview-modal"
      >
        <video width="100%" height="300" controls>
          <source src={get(videoPreview, 'filePath')} type="video/mp4" />
          <track
            src="captions_en.vtt"
            kind="captions"
            srcLang="en"
            label="english_captions"
          />
        </video>
      </Modal>
    </Spin>
  );
};

export default OfferingDetails;
